import { render, staticRenderFns } from "./AddLocationComponent.vue?vue&type=template&id=1c06c1b2&"
import script from "./AddLocationComponent.vue?vue&type=script&lang=js&"
export * from "./AddLocationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports